import { Link } from "react-router-dom";

const StartPage = ({ onStart }) => {
  return (
    <div>
      <div className="h-screen overflow-hidden relative">
        <div class="   p-10 lg:p-10 text-gray-800 relative md:flex items-center text-center md:text-left">
          <div class="w-full">
            <div class="mb-10 lg:mb-20">
              <Link className="flex items-center justify-start gap-3 ">
                <img
                  loading="lazy"
                  src="/images/Frame-1.svg"
                  alt="Hightable_logo"
                />
              </Link>
            </div>
            <div class="mb-10 md:mb-20 text-gray-600 font-light">
              <h2 className="text-2xl md:text-4xl text-gray-800 font-semibold mt-2 md:-mt-6 mb-4 flex gap-2 items-center justify-start">
                Tables Curated Just for You
              </h2>
              <p className="text-sm md:text-base w-[80%] text-gray-600 font-light mb-4">
                Tell us a little about yourself, and we’ll do the rest! Answer a
                few quick questions, and we’ll match you with the perfect
                table—where great food and even better conversations await. Your
                personalized recommendations will land right in your inbox.
              </p>
            </div>
            <div
              onClick={onStart}
              className=" p-3 w-72 z-[50] -mt-8 bg-black border rounded-2xl text-sm md:text-base text-gray-100 cursor-pointer 
                text-left transition-all text-center duration-300"
            >
              Let's Start
            </div>
          </div>
          <img
            className="mt-8 md:mt-0"
            style={{height: "600px", width: "600px", objectFit: "cover"}}
            // src="https://img.freepik.com/free-vector/select-concept-illustration_114360-4251.jpg?t=st=1743508362~exp=1743511962~hmac=a1c6a0bc635b45467f3a0c0d966d0bafca169d3070c3e16ed4560d1d92b4be32&w=826"
            
            // src="/images/WhatsApp Image 2025-11-03 at 10.20.52.jpeg"
            // src="images/WhatsApp Image 2025-11-03 at 10.38.26.jpeg"
            src="/images/WhatsApp Image 2025-11-03 at 10.38.25.jpeg"
            // src="images/WhatsApp Image 2025-11-03 at 10.38.26 (1).jpeg"
            // src="images/WhatsApp Image 2025-11-03 at 10.38.26 (2).jpeg"

            alt="Quiz illustration"
          />
        </div>
        <div class="w-64 md:w-96 h-96 md:h-full bg-blue-200 bg-opacity-30 absolute -top-64 md:-top-96 right-20 md:right-32 rounded-full pointer-events-none -rotate-45 transform"></div>
        <div class="w-96 h-full bg-yellow-200 bg-opacity-20 absolute -bottom-56 left-44 rounded-full pointer-events-none -rotate-45 transform"></div>
      </div>
    </div>
  );
};

export default StartPage;
